// extracted by mini-css-extract-plugin
module.exports = {"svg":"favourites_svg__MTZTS","link":"favourites_link__7tcky","number":"favourites_number__F9Vhp","pulse":"favourites_pulse__TqXeD","pulsing":"favourites_pulsing__dPtf3"};